Namespace 'Monitoring.Models.SocialContents.GoogleMyBusiness.Parsers'

class Monitoring.Models.SocialContents.GoogleMyBusiness.Parsers.GoogleMyBusinessReplyParser
  parse: (replyJson) ->
    reviewSnapshot =
      new Monitoring.Models.SocialContents.GoogleMyBusiness.Parsers.GoogleMyBusinessReviewSnapshotParser()
        .parse(replyJson.review)

    builder = new Monitoring.Models.SocialContents.GoogleMyBusiness.Builders.GoogleMyBusinessReplyBuilder()
    builder.setText(replyJson.text)
    builder.setCreatedAt(new Date(replyJson.created_at * 1000))
    builder.setContentId(replyJson.content_id)
    builder.setReviewSnapshot(reviewSnapshot)
    builder.build()
